import { useContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Toolbar from '@mui/material/Toolbar';
import { Col, Image, Row, Stack } from 'react-bootstrap';
import 'components/sidebar/sidebar.scss';
import 'assets/styles/common.scss';
import { useNavigate, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { LocaleContext } from 'routes/Router';
import {
  doctorDashboard,
  doctorSchedule,
  doctorAppointments,
  doctorPatient,
  doctorProfile,
  doctorSubscription,
  doctorCancel,
  doctorCancelWeb,
  doctorEarning,
} from 'routes/AppUrls';
import { FormattedMessage, useIntl } from 'react-intl';
import Dashboard from 'assets/images/sideBarIcons/dashboard.svg';
import DashboardSelect from 'assets/images/sideBarIcons/dashboard-select.svg';
import Schedule from 'assets/images/sideBarIcons/schedule.svg';
import ScheduleSelect from 'assets/images/sideBarIcons/schedule-select.svg';
import Appointments from 'assets/images/sideBarIcons/appointment.svg';
import AppointmentsSelect from 'assets/images/sideBarIcons/appointment-select.svg';
import Patient from 'assets/images/sideBarIcons/patient.svg';
import PatientSelect from 'assets/images/sideBarIcons/patient-select.svg';
import Profile from 'assets/images/sideBarIcons/profile.svg';
import ProfileSelect from 'assets/images/sideBarIcons/profile-select.svg';
import Subscription from 'assets/images/sideBarIcons/manage-subscription.svg';
import SubscriptionSelect from 'assets/images/sideBarIcons/manage-subscription-select.svg';
import Logout from 'assets/images/sideBarIcons/logout.svg';
import { ClearTokenRedirectLogin } from 'utils/general';
import MenuIcon from '@mui/icons-material/Menu';
import sidebarLogo from 'assets/images/sideBarIcons/side-logo.svg';
import ReusableButton from 'components/commom/Button';
import CommonModal from 'components/commom/Modal';
import { doctorLogout } from 'store/doctorLogout/doctorLogoutAction';
import LocalStorageManager from 'managers/LocalStorageManger';
import {
  ACTIVE_INDEX,
  basicDetailsValue,
} from 'store/BasicDetailValues/BasicDetailValuesAction';
import CommonToast from 'components/commom/CommonToast';

const Sidebar = (props) => {
  const { window } = props;
  const intl = useIntl();
  const params = useParams();
  const navigate = useNavigate();
  const { locale } = useContext(LocaleContext);
  const dispatch = useDispatch();
  const [mobileOpen, setMobileOpen] = useState(false);
  const [isClosing, setIsClosing] = useState(false);
  const { showToast } = CommonToast();
  const [isModal, setIsModal] = useState(false);

  const profileData = useSelector(
    (state) => state?.profileSectionDataReducer?.users?.data
  );

  const aIndex = useSelector((state) => state?.basicDetailsValueReducer);

  const [activeIndex, setActiveIndex] = useState(
    aIndex?.activeIndex >= 0 ? aIndex?.activeIndex : 0
  );

  const profileDisableData = useSelector(
    (state) => state?.profileSectionDataReducer?.users?.data
  );

  const [openSubmenuIndex, setOpenSubmenuIndex] = useState(null);

  const registerReducer = useSelector(
    (state) => state?.doctorLogoutReducer?.loading
  );

  const loginData = useSelector((state) => state?.loginReducer?.users);

  const sidebarData = [
    {
      name: intl.formatMessage({ id: 'Dashboard' }),
      icon: Dashboard,
      selectedIcon: DashboardSelect,
      roles: ['DoctorAdmin', 'SuperAdmin'],
    },
    ...(profileDisableData?.title?.id === 10
      ? []
      : [
          {
            name: intl.formatMessage({ id: 'Schedule' }),
            icon: Schedule,
            selectedIcon: ScheduleSelect,
            roles: ['DoctorAdmin', 'SuperAdmin'],
          },
        ]),
    ...(profileDisableData?.title?.id === 10
      ? []
      : [
          {
            name: intl.formatMessage({ id: 'Appointments' }),
            icon: Appointments,
            selectedIcon: AppointmentsSelect,
            roles: ['DoctorAdmin', 'SuperAdmin'],
          },
        ]),
    ...(profileDisableData?.title?.id === 10
      ? []
      : [
          {
            name: intl.formatMessage({ id: 'My Patients' }),
            icon: Patient,
            selectedIcon: PatientSelect,
            roles: ['DoctorAdmin', 'SuperAdmin'],
          },
        ]),
    ...(profileDisableData?.title?.id === 10
      ? []
      : [
          {
            name: intl.formatMessage({ id: 'Earning' }),
            icon: Patient,
            selectedIcon: PatientSelect,
            roles: ['DoctorAdmin', 'SuperAdmin'],
          },
        ]),
    {
      name: intl.formatMessage({ id: 'Manage Subscription' }),
      icon: Subscription,
      selectedIcon: SubscriptionSelect,
      roles: ['DoctorAdmin', 'SuperAdmin'],
    },
    {
      name: intl.formatMessage({ id: 'Profile' }),
      icon: Profile,
      selectedIcon: ProfileSelect,
      roles: ['DoctorAdmin', 'SuperAdmin'],
    },
    {
      name: intl.formatMessage({ id: 'Logout' }),
      icon: Logout,
      selectedIcon: Logout,
      roles: ['DoctorAdmin', 'SuperAdmin'],
    },
  ];

  const handleSubmenuToggle = (text, index) => {
    setOpenSubmenuIndex(openSubmenuIndex === index ? null : index);
    setActiveIndex(null);
    dispatch(basicDetailsValue(ACTIVE_INDEX, index));
  };
  const handleLogOutModal = () => {
    setIsModal(true);
  };

  const handleLogOut = () => {
    const external = {
      run: true,
      handleFunction: (res) => {
        ClearTokenRedirectLogin(navigate);
      },
      error: true,
      handleErrorFunction: (res) => {
        showToast(res?.message, 'error');
      },
    };
    let body = {};
    dispatch(doctorLogout(body, external));
  };

  const handleSubmenuRedirect = (text, index) => {
    setActiveIndex(index);

    switch (text?.name) {
      case intl.formatMessage({ id: '' }):
        break;
      case intl.formatMessage({ id: '' }):
        break;
      case intl.formatMessage({ id: '' }):
        break;
    }
  };

  const handleDrawerClose = () => {
    setIsClosing(true);
    setMobileOpen(false);
  };

  const handleDrawerTransitionEnd = () => {
    setIsClosing(false);
  };

  const handleDrawerToggle = () => {
    if (!isClosing) {
      setMobileOpen(!mobileOpen);
    }
  };

  const handleMenuItemClick = (text, index) => {
    setOpenSubmenuIndex(null);
    if (text?.name === intl.formatMessage({ id: 'Logout' })) {
      handleLogOutModal();
      return;
    }

    switch (text?.name) {
      case intl.formatMessage({ id: 'Dashboard' }):
        navigate(doctorDashboard(locale));
        break;
      case intl.formatMessage({ id: 'Schedule' }):
        navigate(doctorSchedule(locale));
        break;
      case intl.formatMessage({ id: 'Appointments' }):
        navigate(doctorAppointments(locale));
        break;
      case intl.formatMessage({ id: 'My Patients' }):
        navigate(doctorPatient(locale));
        break;
      case intl.formatMessage({ id: 'Profile' }):
        navigate(doctorProfile(locale));
        break;
      case intl.formatMessage({ id: 'Earning' }):
        navigate(doctorEarning(locale));
        break;
      case intl.formatMessage({ id: 'Manage Subscription' }):
        if (profileData?.subscription === null) {
          navigate(doctorSubscription(locale));
        } else {
          if (params?.token) {
            navigate(
              doctorCancel(locale, LocalStorageManager.getItem('token'))
            );
          } else {
            navigate(doctorCancelWeb(locale));
          }
        }
        break;
    }
    setActiveIndex(index);

    if (!isClosing) {
      setMobileOpen(!mobileOpen);
    }
    dispatch(basicDetailsValue(ACTIVE_INDEX, index));
  };

  const isSidebarDisabled =
    profileDisableData?.doctor_verification?.in_review === true ||
    loginData?.data?.status === 'Pending';

  const filteredSidebarData = sidebarData.filter((item) =>
    item.roles.includes('SuperAdmin')
  );

  useEffect(() => {
    if (aIndex?.activeIndex >= 0) {
      setActiveIndex(aIndex?.activeIndex);
    }
  }, [aIndex]);

  const drawer = (
    <div>
      <Toolbar className={`flex-col justify-center pl-5 pt-5 pr-5 mt-1`}>
        <img src={sidebarLogo} alt={'logo'} />
      </Toolbar>

      <List className="sidebarList ">
        {filteredSidebarData.map((text, index) => (
          <div key={index}>
            <ListItem
              disablePadding
              className={
                text?.name === intl.formatMessage({ id: 'Logout' })
                  ? 'sidebarBottom'
                  : index + 1 === filteredSidebarData?.length - 1
                    ? `mt-3 mb-5 ${activeIndex === index ? 'borderLeftShow' : 'borderLeftWithoutShow'}`
                    : `mt-3 ${activeIndex === index ? 'borderLeftShow' : 'borderLeftWithoutShow'}`
              }
            >
              <ListItemButton
                disabled={
                  isSidebarDisabled &&
                  text?.name !== intl.formatMessage({ id: 'Logout' })
                }
                onClick={() => {
                  if (
                    !isSidebarDisabled ||
                    text?.name === intl.formatMessage({ id: 'Logout' })
                  ) {
                    if (text.children) {
                      handleSubmenuToggle(text, index);
                    } else {
                      handleMenuItemClick(text, index);
                    }
                  }
                }}
                className={`${activeIndex === index || (text.children && openSubmenuIndex === index) ? 'active-menu-item' : ''} 
                   ${isSidebarDisabled && text?.name !== intl.formatMessage({ id: 'Logout' }) ? 'disabled-sidebar-item' : ''}`}
              >
                <ListItemIcon>
                  <Image
                    src={
                      activeIndex === index ||
                      (text.children && openSubmenuIndex === index)
                        ? text?.selectedIcon
                        : text?.icon
                    }
                    alt={'icon'}
                    style={{ height: '24px', width: '24px' }}
                  />
                </ListItemIcon>
                <ListItemText
                  primary={text?.name}
                  className={
                    text?.name === intl.formatMessage({ id: 'Logout' })
                      ? 'Item-logout'
                      : 'Item-text'
                  }
                />
              </ListItemButton>
            </ListItem>

            {text.children && openSubmenuIndex === index && (
              <List className="submenuList pb-0">
                {text.children.map((subItem, subIndex) => (
                  <ListItem
                    key={`${index}-${subIndex}`}
                    className="ml-0"
                    disablePadding
                  >
                    <ListItemButton
                      onClick={() => {
                        handleSubmenuRedirect(subItem, `${index}-${subIndex}`);
                      }}
                      className={
                        activeIndex === `${index}-${subIndex}`
                          ? 'active-submenu-item'
                          : ''
                      }
                    >
                      <ListItemText
                        className="Item-text"
                        primary={subItem.name}
                      />
                    </ListItemButton>
                  </ListItem>
                ))}
              </List>
            )}
          </div>
        ))}
      </List>
    </div>
  );

  const container =
    window !== undefined ? () => window().document.body : undefined;

  return (
    <>
      <Row>
        <Col md={0} lg={2} className="sidebar">
          <Box sx={{ display: 'flex' }}>
            <AppBar>
              <Toolbar className="d-xl-none menu-container">
                <Stack direction="horizontal" gap={4} className="d-flex">
                  <MenuIcon
                    style={{
                      fontSize: '2rem',
                      color: '#292D32',
                      cursor: 'pointer',
                    }}
                    onClick={handleDrawerToggle}
                  />
                  <p className="mb-0 menu-text">
                    <FormattedMessage id="Absolut Skin" />
                  </p>
                </Stack>
              </Toolbar>
            </AppBar>

            <Box component="nav" aria-label="mailbox folders">
              <Drawer
                container={container}
                variant="temporary"
                open={mobileOpen}
                anchor={locale === 'en' ? 'left' : 'right'}
                onTransitionEnd={handleDrawerTransitionEnd}
                onClose={handleDrawerClose}
                ModalProps={{
                  keepMounted: true,
                }}
                sx={{
                  display: { md: 'block', lg: 'none' },
                  '& .MuiDrawer-paper': {
                    boxSizing: 'border-box',
                    width: '240px',
                  },
                }}
              >
                {drawer}
              </Drawer>

              <Drawer
                variant="permanent"
                anchor={locale === 'en' ? 'left' : 'right'}
                className="drawer-menu d-none d-xl-block"
                sx={{
                  '& .MuiDrawer-paper': {
                    boxSizing: 'border-box',
                    borderRight: 'none',
                  },
                }}
                open
              >
                {drawer}
              </Drawer>
            </Box>
          </Box>
        </Col>
      </Row>
      <CommonModal
        padding={'24px'}
        width={'500px'}
        modalActive={isModal}
        innerContent={
          <div>
            <Row>
              <Col xs={12}>
                <div className="">
                  <p className="p-0 m-0 fs-24 fc-292D32 family_outfit_semiBold_600">
                    Are you sure you want to log out?
                  </p>
                </div>
              </Col>
              <Col xs={12} md={12} className="mt-3 flex justify-end">
                <Stack
                  direction="horizontal"
                  gap={2}
                  className="items-center justify-end p-0"
                >
                  <ReusableButton
                    fullWidth={false}
                    variant="outlined"
                    color="#3C3C3C"
                    fontSize="14px"
                    fontWeight="500"
                    padding="12px 50px"
                    height="44px"
                    bgColor="transparent"
                    brColor="#EFE3D7"
                    fontFamily="outfit_medium"
                    onClick={() => setIsModal(false)}
                  >
                    <FormattedMessage id="Cancel" />
                  </ReusableButton>

                  <ReusableButton
                    fullWidth={false}
                    variant="contained"
                    color="#F5F5F5"
                    fontSize="14px"
                    fontWeight="500"
                    padding="12px 50px"
                    height="44px"
                    bgColor="#375241"
                    brColor="#375241"
                    fontFamily="outfit_medium"
                    onClick={() => {
                      !registerReducer && handleLogOut();
                    }}
                    loading={registerReducer}
                  >
                    <FormattedMessage id="Logout" />
                  </ReusableButton>
                </Stack>
              </Col>
            </Row>
          </div>
        }
      />
    </>
  );
};

Sidebar.propTypes = {
  window: PropTypes.func,
};

export default Sidebar;
